import { render, staticRenderFns } from "./Premiacoes.vue?vue&type=template&id=4be02260&scoped=true"
import script from "./Premiacoes.vue?vue&type=script&lang=js"
export * from "./Premiacoes.vue?vue&type=script&lang=js"
import style0 from "./Premiacoes.vue?vue&type=style&index=0&id=4be02260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be02260",
  null
  
)

export default component.exports